import get from 'lodash/get';
import { getItemOrDefaultToValue } from 'utils/details';

export const transformZoneForm = data => {
  const ids = data?.departments &&
    data?.departments.length > 0 && {
      departmentIds: getItemOrDefaultToValue(
        data,
        'departments',
        undefined,
      )?.map(m => m.id),
    };
  return {
    archived: get(data, 'archived', false),
    name: get(data, 'name'),
    regionId: get(data, 'regionId'),
    regionName: get(data, 'regionName'),
    securityCompanyId: get(data, 'securityCompanyId'),
    securityCompanyName: get(data, 'securityCompanyName'),
    ...(ids && { departmentIds: ids.departmentIds }),
    boundary: {
      points: data.locations[0].paths.map(point => ({
        latitude: point.lat,
        longitude: point.lng,
      })),
      centreOfGravity: data.locations[0].paths.reduce(
        (acc, point, idx) => {
          const totalNumberOfElements = point.length;
          if (totalNumberOfElements - 1 === idx) {
            return {
              latitude: (acc.latitude + point.lat) / totalNumberOfElements,
              longitude: (acc.latitude + point.lng) / totalNumberOfElements,
              radius: 100,
            };
          } else {
            return {
              latitude: acc.latitude + point.lat,
              longitude: acc.latitude + point.lng,
              radius: 100,
            };
          }
        },
        {
          latitude: 0,
          longitude: 0,
          radius: 100,
        },
      ),
    },
    currentRisk: {
      context: get(data, 'hazard'),
      description: get(data, 'descriptionIncludingRiskContext'),
      defaultRecommendation: get(data, 'recommendation'),
      likelihood: get(data, 'likelihood'),
      consequence: get(data, 'consequence'),
    },
  };
};
